import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";

export const ContactCard = () => {
  return (
    <motion.div
      data-testid="contact-card"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.85, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto w-full max-w-[340px] rounded-[26px] border border-white/15 bg-white/10 p-4 backdrop-blur-2xl"
      style={{ boxShadow: "0 18px 40px rgba(3,20,45,0.45), inset 0 1px 1px rgba(255,255,255,0.25)" }}
    >
      <p className="mb-3 px-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-white/45">
        Contact your consultant
      </p>

      <a
        href="mailto:arora.sukhvinder@eybconsulting.com.au"
        data-testid="contact-email"
        className="flex items-center gap-3 rounded-2xl px-2 py-2.5 transition-colors duration-200 hover:bg-white/10 active:bg-white/15"
      >
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-b from-[#2EC1F0] to-[#1273C4]"
          style={{ boxShadow: "inset 0 1px 1px rgba(255,255,255,0.4)" }}>
          <Mail size={17} className="text-white" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] text-white/50">Email</p>
          <p className="break-all text-[13px] font-medium leading-snug text-white">
            arora.sukhvinder@eybconsulting.com.au
          </p>
        </div>
      </a>

      <div className="my-1 h-px bg-white/10" />

      <a
        href="tel:0423214179"
        data-testid="contact-phone"
        className="flex items-center gap-3 rounded-2xl px-2 py-2.5 transition-colors duration-200 hover:bg-white/10 active:bg-white/15"
      >
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-b from-[#38D6B5] to-[#0E8FA8]"
          style={{ boxShadow: "inset 0 1px 1px rgba(255,255,255,0.4)" }}>
          <Phone size={17} className="text-white" />
        </span>
        <div>
          <p className="text-[11px] text-white/50">Phone</p>
          <p className="text-sm font-medium text-white">0423 214 179</p>
        </div>
      </a>
    </motion.div>
  );
};
